import React, { useState, useEffect } from "react";
import Flink from '~/components/shared/flink'
import { notBlank } from '~/utils/helpers'

import { IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/stores/our_stores.module.scss"


const StoresRegion = ({ region }) => {
  const [open, setOpen] = useState(true)

  const handleClick = () => {
    setOpen( !open )
  }

  useEffect(() => {
    if (!region?.distance) return
    setOpen(region?.distance <= 100)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region.distance])

  return (
    <div className={styles.region}>
      <div className={styles.head}>
        <h2 className={styles.title}>
          <button 
            type="button"
            className={`${aria_btn} ${styles.title} ${styles.region_btn}`}  
            aria-label="Toggle this region's stores" 
            onClick={(e) => handleClick()}
          >
            {region.region}
          </button>
        </h2>
        <div className={`${styles.region_hide} ${open ? styles.collapse : ''}`}>
          <button 
            type="button"
            className={aria_btn} 
            aria-label="Toggle this region's stores" 
            onClick={(e) => handleClick()}
          >
            <IconChevRight icon_classes={styles.icon_chev} />
          </button>
        </div>
      </div>
      <div className={styles.region_stores} style={{maxHeight: open ? '500em' : '0px'}}>
        {region.stores.map( (store,index) => 
          <div 
            key={`rs_${store.page}${index}`}
            className={`${styles.store} ${store.placeholder ? styles.placehold : ''}`}
          >
            <div className={styles.info}>
              {!store.placeholder ? (
                <div className={styles.store_title}>
                  {notBlank(store.page) ? (
                    <Flink href={`/pages/${store.page}`}>{store.title}</Flink>
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: store.title }} />
                  )}
                  {store.distance && (
                    <>
                      &nbsp;<div className={styles.dist}>({store.distance}mi away)</div>
                    </>
                  )}
                </div>
              ) : (
                <div className={styles.title}>
                  {store.title}
                </div>
              )}
            </div>
            {!store.placeholder && (
              <>
                <div className={styles.address}>
                  <p>
                    {notBlank(store.address_line_1) && (
                      <>
                        {store.address_line_1}
                        <br/>
                      </>
                    )}
                    {notBlank(store.address_line_2) && (
                      <>
                        {store.address_line_2}
                        <br/>
                      </>
                    )}
                   {notBlank(store.address_city) && (
                      <>
                        {store.address_city}, {store.address_state} {store.address_zip}
                        <br/>
                      </>
                    )}
                   {notBlank(store.phone) && (
                     <a href={`tel:${store.phone.replaceAll('.', '').replaceAll('-', '')}`}>
                       {store.phone}
                     </a>
                   )}
                  </p>
                  
                  {notBlank(store.gmaps) && (
                    <p className={styles.gmaps}>
                      <a  
                        href={`https://www.google.com/maps/dir/?api=1&destination=${store.gmaps}`} 
                        rel="noreferrer" 
                        target="_blank"
                      >
                        Map
                      </a>
                    </p>
                  )}
                </div>
                <div>
                  {notBlank(store.hours) && store.hours.split('\n').map( (time,index) => 
                    <React.Fragment key={`${store.short_name}}time${index}`}>
                      {time}
                      <br/>
                    </React.Fragment>
                  )}
                </div>

                <div className={styles.details}>
                  <div className={styles.at_this}>
                    At This Store
                  </div>
                  {store.avail_mens && (
                    <p>
                      Men's
                    </p>
                  )}
                  {store.avail_womens && (
                    <p>
                      Women's
                    </p>
                  )}
                  {store.pickup_enabled && (
                    <p>
                      In-Store Pickup
                    </p>
                  )}
                  {store.avail_watches && (
                    <p>
                      Vintage Watches
                    </p>
                  )}
                  {store.avail_vintclothes && (
                    <p>
                      Vintage Clothes
                    </p>
                  )}
                  {store.avail_books && (
                    <p>
                      Bookstore
                    </p>
                  )}
                  {store.avail_coffee && (
                    <p>
                      <a href="https://www.fasttimescoffee.com" target="_blank" rel="noreferrer">
                        Fast Times Coffee
                      </a>
                    </p>
                  )}
                </div>
              </>
            )}
            <div className={styles.dir}>
              {store.placeholder && (
                <span className={styles.more}>
                  {store.more ? store.more : 'Coming Soon'}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StoresRegion

